export default __webpack_public_path__ + "static/media/footer-bg.78298c03.png";